import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100 cloud_opt_process"
      style={{ backgroundColor: "#F6F6F6" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={11} lg={10} className="m-auto text-center">
            <h3 className="h3_head">
              Optimizing Efficiency: Our Comprehensive Cloud{" "}
              <span>App Development Process</span>
            </h3>
            <p>
              The process involved in our cloud application development services
              focuses on the creation of cloud applications that are reliable,
              scalable, and highly secure. We work professionally using high-end
              technology standards and adopting a systematic methodology in
              developing quality solutions for your company. Here are the key
              phases that we employ when developing cloud applications:
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">01</div>
              <div className="rapid_content">
                <h5>Requirement Analysis</h5>
                <p>
                  We analyze your business requirements and technical
                  constraints using tools like Jira and Confluence for detailed
                  documentation and project tracking.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">02</div>
              <div className="rapid_content">
                <h5>Architecture Design</h5>
                <p>
                  Our architects design scalable, resilient cloud architectures
                  using microservices, containerization (Docker, Kubernetes),
                  and serverless computing (AWS Lambda, Azure Functions).
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">03</div>
              <div className="rapid_content">
                <h5>Development and Testing</h5>
                <p>
                  Our cloud app developers use CI/CD pipelines with Jenkins,
                  GitLab CI, and automated testing frameworks (Selenium, JUnit)
                  to ensure high-quality code and rapid delivery.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">04</div>
              <div className="rapid_content">
                <h5>Deployment</h5>
                <p>
                  We deploy applications using Infrastructure as Code (IaC) with
                  Terraform or AWS CloudFormation for consistent, repeatable
                  deployments across environments.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">05</div>
              <div className="rapid_content">
                <h5>Monitoring and Optimization</h5>
                <p>
                  Post-deployment, we implement monitoring solutions
                  (Prometheus, Grafana) and use cloud-native tools for
                  performance monitoring and resource optimization.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">06</div>
              <div className="rapid_content">
                <h5>Maintenance and Scaling</h5>
                <p>
                  Our ongoing maintenance includes updates, security patches,
                  and scaling with auto-scaling groups and load balancers to
                  handle increased demand seamlessly.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
